// @flow

import { LEFT_TO_RIGHT, RIGHT_TO_LEFT, type ReadingDirection } from './types';
import { type IncomingPayment } from '@tectonics/prs/incoming-payment';
import { getCurrentLanguage } from '@tectonics/controller/language/language-service';

export function getReadingDirectionByIncomingPayment(incomingPayment: IncomingPayment): ReadingDirection {
  const { country } = incomingPayment;
  const language: string = getCurrentLanguage();
  return getDirectionByCountryAndLanguage(country, language);
}

function getDirectionByCountryAndLanguage(country: string, language: string): ReadingDirection {
  const EGYPT_COUNTRY = 'eg';
  const ARABIC_LANGUAGE = 'ar';
  const isRTL: boolean = (country === EGYPT_COUNTRY) && (language === ARABIC_LANGUAGE);

  return isRTL ? RIGHT_TO_LEFT : LEFT_TO_RIGHT;
}
